import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';

import './styles.scss';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../components/forms';
import {addToWizard, setWizard} from '../../../../store/actions';
import * as Yup from 'yup';
import {strings} from '../../../../util/strings';
import {Column, Row} from '../../../../components/layout';
import Header2 from '../../../../components/headers/header2';
import {createGUID, getDateInServerFormat} from '../../../../util/utility';
import {post, get} from '../../../../api/api';
import {
  uriCreateUser,
  uriRequestActivationCode,
} from '../../../../api/endpoints';
import {useHistory} from 'react-router-dom';
import ActivateRegistration from '../data-validation/activate-registration';
import {Icons} from '../../../../util/icons';
import colors from '../../../../util/colors';
import NewErrorMessage from '../../../../components/new-error-message';
import AppErrorMessage from '../../../../components/app-error-message';

export interface DataValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  wizard: any;
  addToWizard(value: any): any;
  setWizard(value: any): any;
  labels: typeof strings.pt.register;
  messageLabels: typeof strings.pt.messages;
  language: string;
}

function AccountData({
  valid,
  setValid,
  wizard,
  labels,
  messageLabels,
  addToWizard,
  onSubmit,
  nextStep,
  language,
}: DataValidationProps) {
  const [submitting, setSubmitting] = useState(false);
  const [formikContext, setFormikContext] = useState();
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [typeOfError, setTypeOfError] = useState<any>();
  const [currentFormValues, setCurrentFormValues] = useState<any>({
    email: '',
    password: '',
    repeatPassword: '',
  });
  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>({
    email: false,
    password: false,
    repeatPassword: false,
  });
  const [guid, setGuid] = useState(
    (wizard &&
      wizard.activateRegistration &&
      wizard.activateRegistration.guid) ||
      ''
  );
  const [viewPassword, setViewPassword] = useState(false);
  const [viewRepeatPassword, setViewRepeatPassword] = useState(false);

  const handlePasswordIconClick = (repeat: boolean) => {
    if (repeat) {
      setViewRepeatPassword(!viewRepeatPassword);
    } else {
      setViewPassword(!viewPassword);
    }
  };

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: true});
      };
      icon.onmouseout = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: false});
      };
    }
  };

  const expression =
    /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  const isEmailAllowed = (email: any) => {
    return expression.test(String(email).toLowerCase());
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required(messageLabels?.requiredField)
      .email(messageLabels.invalidEmailFormat)
      .test('email-format-invalid', labels?.emailPassword_emailError, (value) =>
        isEmailAllowed(value)
      ),
    password: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp('^(?!.* )(?=.*\\d)(?=.*[A-Z]).{8,}'),
        labels?.emailAndPassword_passwordError
      )
      .label(''),
    repeatPassword: Yup.string()
      .required(messageLabels?.requiredField)
      .oneOf([Yup.ref('password')], messageLabels.passwordsDontMatch),
  });

  if (!!!wizard.insuranceValidation) {
    history.push('/');
  }

  const emailErrorMessages =
    (formikContext &&
      (formikContext as any).errors &&
      (formikContext as any).errors.email) ||
    '';

  const passwordErrorMessages =
    (formikContext &&
      (formikContext as any).errors &&
      (formikContext as any).errors.password) ||
    '';

  const repeatPasswordErrorMessages =
    (formikContext &&
      (formikContext as any).errors &&
      (formikContext as any).errors.repeatPassword) ||
    '';

  const existingEmail =
    (wizard &&
      wizard.dataValidation &&
      wizard.dataValidation?.currentUser?.email) ||
    '';

  switch (visible) {
    case false:
      return (
        <Column className="account-data-container">
          <AppForm
            initialValues={{
              email: existingEmail,
              password: '',
              repeatPassword: '',
            }}
            onChange={(values: any) => {
              if (values.email !== currentFormValues.email)
                setCurrentFormValues({
                  ...currentFormValues,
                  email: values.email,
                });

              if (values.password !== currentFormValues.password)
                setCurrentFormValues({
                  ...currentFormValues,
                  password: values.password,
                });

              if (values.repeatPassword !== currentFormValues.repeatPassword)
                setCurrentFormValues({
                  ...currentFormValues,
                  repeatPassword: values.repeatPassword,
                });
            }}
            validationSchema={validationSchema}
            onValidation={(valid) => setValid(valid)}
            onSubmit={async (values) => {
              setSubmitting(true);
              const aux: string = wizard.dataValidation.currentUser.phone;
              let buId: string | null = null;
              let memId: string | null = null;
              switch (wizard.dataValidation.currentUser.buId) {
                case 'noInsurance':
                  break;
                case 'otherEntity':
                  buId = 'Outra';
                  break;
                default:
                  buId = wizard.dataValidation.currentUser.buId;
                  memId = wizard.dataValidation.cardNumber;
              }

              const state: string = wizard.dataValidation.state || null;

              const phoneNumber = aux
                ? aux.indexOf('+') >= 0
                  ? aux?.split('+')[1]
                  : aux
                : '';

              const guid = createGUID();

              const user = {
                userName: values.email,
                password: values.password,
                fullName: wizard.insuranceValidation.name,
                email: values.email,
                phoneNumber: phoneNumber,
                nif: wizard.insuranceValidation.nif,
                doB: getDateInServerFormat(
                  wizard.insuranceValidation.dateOfBirth
                ),
                cc: wizard.dataValidation.otherEntity || '',
                activationId: guid,
                sessionId: guid,
                buId: buId,
                state: !!state ? state : null,
                memId: memId,
                language: language,
              };

              if (wizard.dataValidation.selectedContact === values.email) {
                //Se o email inserido é igual ao selecionado [PARA UTILIZADORES COM CONTACTO NO RIOS] acabar o registo

                try {
                  const tenantAlias = process.env
                    .REACT_APP_DEFAULT_TENANT_ALIAS as string;
                  await fetch(uriCreateUser(), {
                    method: 'POST',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      X_MYADV_API_KEY: tenantAlias,
                    },
                    body: JSON.stringify(user),
                  });
                  setVisible(true);
                  history.push('/registo-completo');
                } catch (e: any) {
                  if (e.status === 500) {
                    (formikContext as any).setFieldError(
                      'email',
                      labels?.emailPassword_existingUsername
                    );
                    setTypeOfError(e);
                  }
                  setVisible(false);
                }
              } else {
                //Email inserido diferente do Selecionado (no caso de utilizadores com email no RIOS ou utilizadores sem contactos [onde o email selecionado é  ''])
                const newSelectedContact = values.email;
                const newSelectedContactType = 'EMAIL'; // redudante se for no caso de não ter contactos no RIOS mas necessário se for o caso de ter contactos -> validado telefone -> validar email

                //fazer a chamada a api de activation code para verificar se traz erro 404 (o email que está a tentar registar já existe em rios)
                try {
                  await post(
                    uriRequestActivationCode(),
                    JSON.stringify({
                      senderType: newSelectedContactType,
                      destination: newSelectedContact,
                      sessionGuid: guid,
                      name: wizard.insuranceValidation.name,
                      buId: wizard?.user?.buId,
                    })
                  )
                    .then((resp) => {
                      addToWizard({user});
                      addToWizard({
                        dataValidation: {
                          ...wizard.dataValidation,
                          selectedContact: newSelectedContact,
                          selectedContactType: newSelectedContactType,
                        },
                      });
                      addToWizard({activateRegistration: {guid}});
                      setGuid(guid);
                      setVisible(true);
                    })
                    .catch((error) => {
                      if (error.status === 400) {
                        (formikContext as any).setFieldError(
                          'email',
                          labels?.emailPassword_existingUsername
                        );
                        setTypeOfError(error);
                      } else if (error.status >= 500 && error.status < 600) {
                        setTypeOfError(error);
                      }
                      setVisible(false);
                    });
                } catch (e: any) {
                  if (e.status === 400) {
                    (formikContext as any).setFieldError(
                      'email',
                      labels?.emailPassword_existingUsername
                    );
                    setTypeOfError(e);
                  }
                }
              }

              setSubmitting(false);
            }}>
            <Header2 className="enter-code-header">
              {labels?.emailAndPassword_pageSubTitle}
            </Header2>
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                handleFormikContext={(formik) => {
                  if (
                    !!!formikContext ||
                    formik.errors !== (formikContext as any).errors
                  ) {
                    setFormikContext(formik);
                  }
                }}
                name="email"
                placeholder={labels?.emailAndPassword_emailPlaceholder}
                className="account-data-input-email"
                onMouseOver={(e) => {
                  defineOnMouseFunctions(e, 'email');
                }}
              />
              {emailErrorMessages.length > 0 && hoverErrorIcons.email && (
                <AppErrorMessage
                  message={emailErrorMessages}
                  className={'account-data-pop-up-email-error-messages'}
                />
              )}
            </Row>
            <hr className="account-data-hr" />
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                name="password"
                type={viewPassword ? '' : 'password'}
                passwordIcon={true}
                pwdIconClass={
                  passwordErrorMessages.length > 0
                    ? 'register-pwd-eye-hidden'
                    : 'register-pwd-eye'
                }
                className="repeat-password"
                handlePasswordIconClick={() => handlePasswordIconClick(false)}
                showPassword={viewPassword}
                placeholder={labels.emailAndPassword_passwordPlaceholder}
                onMouseOver={(e) => {
                  defineOnMouseFunctions(e, 'password');
                }}
              />
              {passwordErrorMessages.length > 0 && hoverErrorIcons.password && (
                <AppErrorMessage
                  message={passwordErrorMessages}
                  className={
                    passwordErrorMessages === messageLabels?.requiredField
                      ? 'account-data-pop-up-password-error-messages'
                      : 'account-data-pop-up-password-error-messages-match'
                  }
                />
              )}
            </Row>
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                name="repeatPassword"
                type={viewRepeatPassword ? '' : 'password'}
                passwordIcon={true}
                pwdIconClass={
                  repeatPasswordErrorMessages.length > 0
                    ? 'register-pwd-eye-hidden'
                    : 'register-pwd-eye'
                }
                className="repeat-password"
                handlePasswordIconClick={() => handlePasswordIconClick(true)}
                showPassword={viewRepeatPassword}
                placeholder={labels.emailAndPassword_confirmPasswordPlaceholder}
                onMouseOver={(e) => {
                  defineOnMouseFunctions(e, 'repeatPassword');
                }}
              />
              {repeatPasswordErrorMessages.length > 0 &&
                hoverErrorIcons.repeatPassword && (
                  <AppErrorMessage
                    message={repeatPasswordErrorMessages}
                    className={
                      'account-data-pop-up-repeat-password-error-messages'
                    }
                  />
                )}
            </Row>
            {/* <Row className="app-center">
              <ErrorMessage visible error={submitError} />
            </Row> */}
            {!!typeOfError && (typeOfError.status === 400) && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={
                  labels?.register_usernameAlreadyRegistered
                }></NewErrorMessage>
            )}

            {!!typeOfError &&
              typeOfError.status !== 400 &&
              typeOfError.status >= 500 &&
              typeOfError.status < 600 && (
                <NewErrorMessage
                  key={typeOfError}
                  iconName={Icons.ALERT_PROBLEM}
                  colorIcon={colors.alertRed}
                  text={messageLabels.general_errorMessage}></NewErrorMessage>
              )}
            <Row className="app-center">
              <AppFormSubmitButton
                title={labels?.register_beforeContinueButtonText}
                disabled={!valid || submitting}
                className="stepper-continue-button account-data-continue-button"
              />
            </Row>
          </AppForm>
        </Column>
      );
    case true:
      return (
        <ActivateRegistration
          setValid={setValid}
          valid={valid}
          onSubmit={onSubmit}
          nextStep={nextStep}
        />
      );
  }
}

const mapStateToProps = ({wizard, stringsDefault}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.register,
  messageLabels: stringsDefault.value.pt.messages,
  labelsGeneralErrors: stringsDefault.value.pt.message,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AccountData)
);
